// extracted by mini-css-extract-plugin
export default {"overlayToaster":"Message_overlayToaster__IfPck","extraClass":"Message_extraClass__HJa8Q"};